export const AUCTION_PROGRAM_HALLS = {
    AUCTION_A: { value: "A", text: "Online Auction" },
    AUCTION_B: { value: "B", text: "After Sale Online" },
};

export const WORK_CLASSIFICATION_TYPES = {
    NULL: { text: "없음", value: "work_classification_type:NULL" },
    DESC: { text: "텍스트", value: "work_classification_type:DESC" },
    LIST: { text: "리스트", value: "work_classification_type:LIST" },
};

export const WORK_AUCTION_MODES = {
    NULL: { text: "없음", value: "work_mode_auction_type:NULL" },
    PRIVATE: { text: "프라이빗", value: "work_mode_auction_type:PRIVATE" },
    PROGRAM: { text: "프로그램", value: "work_mode_auction_type:PROGRAM" },
};

export const USER_TYPES = {
    PERSON: { text: "일반회원", value: "PERSON" },
    COMPANY: { text: "기업회원", value: "COMPANY" },
};

export const USER_NOTIFY_METHODS = {
    SMS: { text: "SMS(문자메시지)", value: "user.notification:SMS" },
    EMAIL: { text: "이메일", value: "user.notification:EMAIL" },
    PHONE: { text: "전화", value: "user.notification:PHONE" },
};

const man = 10000;
export const BID_UNIT_POLICIES = [
    { value: 5 * man, test: (value) => value < 100 * man, text: "100만원 미만" },
    { value: 10 * man, test: (value) => value < 300 * man, text: "100만원 이상 ~ 300만원 미만" },
    { value: 20 * man, test: (value) => value < 500 * man, text: "300만원 이상 ~ 500만원 미만" },
    { value: 30 * man, test: (value) => value < 1000 * man, text: "500만원 이상 ~ 1,000만원 미만" },
    { value: 50 * man, test: (value) => value < 3000 * man, text: "1,000만원 이상 ~ 3,000만원 미만" },
    { value: 100 * man, test: (value) => value < 5000 * man, text: "3,000만원 이상 ~ 5,000만원 미만" },
    { value: 200 * man, test: (value) => value < 10000 * man, text: "5,000만원 이상 ~ 1억원 미만" },
    { value: 300 * man, test: (value) => value < 20000 * man, text: "1억원 이상 ~ 2억원 미만" },
    { value: 500 * man, test: (value) => value < 50000 * man, text: "2억원 이상 ~ 5억원 미만" },
    { value: 1000 * man, test: (value) => value >= 50000 * man, text: "5억원 이상" },
];

export const DELIVERY_POLICIES_DOMESTIC = [
    { value: 50000, text: "서울", test: (value) => [/^서울/].some((item) => item.test(value)) },
    { value: 100000, text: "수도권", test: (value) => [/^경기/, /^인천/].some((item) => item.test(value)) },
    { value: 150000, text: "그 외 국내지역", test: () => true },
];

export const PRIVATE_SALES_TABS = {
    UWSS: { value: "UWSS", text: "UWSS" },
    WEB: { value: "WEB", text: "WEBCastle" },
    WS: { value: "WS", text: "WSFinder" },
    WMDS: { value: "WMDS", text: "WMDS" },
};

export const PRIVATE_SALES_EN_TABS = {
    UWSS: { value: "UWSS", text: "UWSS" },
    WEB: { value: "WEB", text: "WEBCastle" },
    WS: { value: "WS", text: "WSFinder" },
    WMDS: { value: "WMDS", text: "WMDS" },
};

export const ABOUT_US_TABS = {
    COMPANY: { value: "COMPANY", text: "회사소개" },
    NEWS: { value: "NEWS", text: "기사·뉴스" },
    LOCATION: { value: "LOCATION", text: "위치 및 연락처" },
};

export const ABOUT_US_EN_TABS = {
    COMPANY: { value: "COMPANY", text: "Company" },
    NEWS: { value: "NEWS", text: "News" },
    LOCATION: { value: "LOCATION", text: "Location" },
};

export const RESOURES_TABS = {
    UWSSRESOURCES: { value: "UWSSRESOURCES", text: "UWSS Resources" },
    COUSTOMER: { value: "COUSTOMER", text: "Customer Stories" },
};
export const RESOURES_EN_TABS = {
    UWSSRESOURCES: { value: "UWSSRESOURCES", text: "UWSS Resources" },
    COUSTOMER: { value: "COUSTOMER", text: "Customer Stories" },
};

export const HOW_TO_BID_TABS = {
    JOIN: { value: "JOIN", text: "회원가입" },
    PREVIEW: { value: "PREVIEW", text: "프리뷰" },
    ONLINE: { value: "ONLINE", text: "온라인경매" },
    LIVE: { value: "LIVE", text: "라이브경매" },
    NOTICE: { value: "NOTICE", text: "유의사항" },
    SUCCESS: { value: "SUCCESS", text: "낙찰 및 수수료" },
    DELIVERY: { value: "DELIVERY", text: "픽업 및 배송" },
};

export const BOARD_YOUTUBE_CATEGORIES = {
    ARTS_HISTORY: { value: "ARTS_HISTORY", text: "디테일 미술사(작품탐구)" },
    PRICE_TRENDS: { value: "PRICE_TRENDS", text: "가격 동향 분석" },
    WORLD_TRENDS: { value: "WORLD_TRENDS", text: "해외미술 동향" },
    MANAGE_USAGE: { value: "MANAGE_USAGE", text: "미술품 관리와 활용" },
};

export const BOARD_RESOURCE_CATEGORIES = {
    ARTS_HISTORY: { value: "LIBRARY", text: "library" },
    PRICE_TRENDS: { value: "CUSTOMER", text: "customer" }
};

export const BOARD_PARTNERS_CATEGORIES = {
    ARTS_HISTORY: { value: "국내", text: "국내" },
    PRICE_TRENDS: { value: "해외", text: "해외" }
};

export const BOARD_REPORT_CATEGORIES = {
    ARTS_HISTORY: { value: "ARTS_HISTORY", text: "양식 미술사" },
    PRICE_TRENDS: { value: "PRICE_TRENDS", text: "가격 동향 분석" },
    WORLD_TRENDS: { value: "WORLD_TRENDS", text: "해외미술 동향" },
    MANAGE_USAGE: { value: "MANAGE_USAGE", text: "미술품 관리와 활용" },
};

export const BOARD_FORMS_CATEGORIES = {
    AUCTION_FORMS: { value: "AUCTION_FORMS", text: "경매 서식" },
    AUCTION_INFSO: { value: "AUCTION_INFOS", text: "경매 정보" },
    ART_NARRATIVE: { value: "ART_NARRATIVE", text: "미술 이야기" },
    CONSULTATIONS: { value: "CONSULTATIONS", text: "아트 컨설팅" },
};
